import React from 'react'
import Chip from '@mui/material/Chip'

const PayoutChips = ({ isVerified }) => {
  return (
    <Chip size='small' label={isVerified ? "Verified" : "Not verifed"} color={isVerified ? "success" : "error"} variant='outlined' />
  )
}

export default PayoutChips